import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "message-stream" }
const _hoisted_2 = {
  key: 0,
  class: "blinking-cursor"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src"]

import vue from '../../../../adapter-vue';
import { IMessageLargeStreamPayload } from '../../../../interface';
import { parseMarkdown } from './message-desk/message-desk-elements/marked';
import { TypeWriter } from "./message-desk/message-desk-elements/type-writer";
import { JSONToObject } from "../../../../utils";

interface Props {
  content: IMessageLargeStreamPayload;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'message-large-stream',
  props: {
    content: { default: () => ({} as IMessageLargeStreamPayload) }
  },
  emits: ['heightChanged'],
  setup(__props: any, { emit: __emit }) {

const { ref, computed, watch, onMounted, onUnmounted } = vue;

const props = __props;

const isCursorBlinking = ref<boolean>(true);
const isStreaming = ref<boolean>(false);
const image = ref(false);
const imageSrc = ref('');
const markdown = ref<string>('');
const isStreamEnded = ref<boolean>(true);
const prevmarkdownLength = ref<number>(0);
const streamContent = ref<string>('');
const displayedContent = computed(() => {
  // @ts-ignore
  window.onMarkdownImageClicked = function(href:string) {
    image.value = !image.value;
    imageSrc.value = decodeURIComponent(href);
  }
  // @ts-ignore
  window.onMarkdownMediaLoad = function() {
    // empty implementation
    // 已经用 ResizeObserver 观测高度，这里不用重复通知高度变化
  }
  const result = parseMarkdown(streamContent.value);
  return result;
});
const preRef = ref();
const emits = __emit;
// 不支持 ResizeObserver 的浏览器太老旧，默认不处理了
const canIUseResizeObserver = typeof ResizeObserver === 'undefined' ? false : true;

let observer;
let prevHeight;

const typeWriter = new TypeWriter({
  batchSize: 2,
  onTyping: (item: string) => {
    streamContent.value += item;
  },
  onComplete() {
    isStreaming.value = false;
  },
});

function startStreaming(content: string[]) {
  if (!isStreaming.value) {
    isStreaming.value = true;
    typeWriter.add(content);
    typeWriter.start();
  } else {
    typeWriter.add(content);
  }
}

watch(() => props.content, (newValue: IMessageLargeStreamPayload, oldValue: IMessageLargeStreamPayload) => {
    if (!newValue || (oldValue && newValue.markdown === oldValue.markdown)) {
      return;
    }
    const _payloadObject = props.content;
    if (_payloadObject.errorCode !== 0 || !_payloadObject.markdown) {
      return;
    }
    markdown.value =  _payloadObject.markdown || '';
    isStreamEnded.value = _payloadObject.isStreamEnded;

    // hide blinking cursor
    if (markdown.value.length > 0) {
      isCursorBlinking.value = false;
    }
    if (newValue && ((!oldValue && isStreamEnded.value) || markdown.value.length > 500)) {
      // disable typeWriter style or history message first load
      streamContent.value = markdown.value;
      prevmarkdownLength.value = markdown.value.length;
    } else {
      // 判断长度是为了防御编辑的内容回退和内容重复的异常 case
      if (markdown.value.length > prevmarkdownLength.value) {
        const _newmarkdownToAdd = markdown.value?.slice(prevmarkdownLength.value);
        prevmarkdownLength.value = markdown.value.length;
        startStreaming([_newmarkdownToAdd]);
      }
    }
  }, {
    deep: true,
    immediate: true,
  },
);

onMounted(() => {
  if (canIUseResizeObserver) {
    observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        observeHeightChanged(entry.contentRect.height);
      }
    });
    // 开始观察
    observer.observe(preRef.value);
  }
});

onUnmounted(() => {
  if (canIUseResizeObserver) {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }
});

const observeHeightChanged = (newHeight) => {
  if (prevHeight !== newHeight) {
    prevHeight = newHeight;
    emits('heightChanged');
  }
};

const closeImage = () => {
  image.value = !image.value;
  imageSrc.value = '';
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isCursorBlinking))
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "|"))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "preRef",
        ref: preRef,
        class: _normalizeClass(['message-marked']),
        innerHTML: _unref(displayedContent)
      }, null, 8, _hoisted_3)
    ]),
    (_unref(image))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "rich-image-previewer",
          onClick: closeImage
        }, [
          _createElementVNode("img", {
            class: "rich-image-preview",
            src: _unref(imageSrc)
          }, null, 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})